import gql from 'graphql-tag'

export const gqlConsultaTarifaCliente = gql`
  query consultaTarifaCliente($idConta: String!) {
    consultaTarifaCliente(idConta: $idConta) {
      statusCode
      result {
        id
        atividade
        condicaoComercial
        valorTarifa
        status
        detalhe {
          titulo
          valorTarifaDescricao
          descricao
        }
      }
      error {
        code
        message
      }
    }
  }
`
